import React from "react";
import { useTranslation } from "react-i18next";
import Heading from "@/components/atoms/Heading";
import { Grid, Stack } from "@mantine/core";
import Text from "@/components/atoms/Text";
import { SettingsFormContent, SettingsHeader } from "@/components/pages/Settings/index";
import ContractTemplatesTable from "@/components/organisms/ContractTemplatesTable";

const Templates = () => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Heading order={2} styleOrder={4} tt="uppercase">
        {t("settings:navigation.templates")}
      </Heading>
      <SettingsFormContent>
        <Grid>
          <SettingsHeader showDivider={false}>
            <Text size="md" strong={true} display="technical" tt="uppercase" data-testid="standard-contracts-header">
              {t("settings:templates.standardContracts")}
            </Text>
          </SettingsHeader>
          <Grid.Col span={12}>
            <ContractTemplatesTable pagination={false} actionable={false} />
          </Grid.Col>
        </Grid>
      </SettingsFormContent>
    </Stack>
  );
};

export default Templates;
